export default class InvalidCustomerDocumentBankStatementMagicLinkToken extends Error {
  constructor(message: string) {
    super(message);
  }
}
